import moment from 'moment';
import { sortBy } from 'lodash';
import { fromObjToArray } from '../../utils/object';
import { sortByDate } from '../../utils/date';
import { isRunner, duplicateArrayVals } from './formTable/helper';

const getSpecialRow = (specialText, raceDatetime) => ({
    isSpecial: true,
    raceDatetime,
    specialText,
});

const geldRow = getSpecialRow.bind(null, 'Gelded notification');
const windRow = ({ medicalDate, medicalType }) => getSpecialRow(medicalType, medicalDate);

const trainersRows = (previousTrainers, currentTrainer) =>
    previousTrainers
        .sort(sortByDate('trainerChangeDate'))
        .map(({ trainerChangeDate, ...trainer }, i) => ({
            isSpecial: true,
            raceDatetime: trainerChangeDate,
            trainerFrom: trainer,
            trainerTo: previousTrainers[i - 1] || currentTrainer,
        }));

const isMoreThen50Days = daysCount => daysCount >= 50;


const DATE_FORMAT = 'YYYY-MM-DD';

const breakRows = form => sortBy(form, 'raceDatetime')
    .filter(isRunner)
    .map((row, i, arr) =>
        (i < arr.length ?
            { prev: row, next: arr[i + 1] } :
            null)
    )
    .reduce((acc, current) => {
        const { prev, next } = current;
        if (!prev || !next) { return acc; }

        let day = moment(prev.raceDatetime).format(DATE_FORMAT);
        const timePrev = moment(day);
        day = moment(next.raceDatetime).format(DATE_FORMAT);
        const timeNext = moment(day);
        const daysBreak = Math.abs(timePrev.diff(timeNext, 'days'));

        return isMoreThen50Days(daysBreak) ?
        [...acc, {
            raceDatetime: moment(next.raceDatetime).subtract(1, 'second').format(),
            daysBreak,
            isSpecial: true }] :
        acc;
    }, []);


const transformData = (data) => {
    if (!data) return {};

    const {
        raceRecords: {
            lifetimeRecords: records,
            jumpsFiguresCalculated: jumps,
            flatFiguresCalculated: flat,
        },
        profile: {
            dateGelded,
            previousTrainers,
            trainerUid,
            trainerName: trainerStyleName,
            medical,
        },
        form,
    } = data;
    const currentTrainer = { trainerStyleName, trainerUid };
    const gelded = dateGelded ? [geldRow(dateGelded)] : [];
    const medicalData = medical ? medical.map(windRow) : [];
    const trainers = previousTrainers ?
        trainersRows(previousTrainers, currentTrainer) : [];
    const breaks = duplicateArrayVals(breakRows([...Object.values(form)]));

    const specialRows = [...medicalData, ...gelded, ...trainers, ...breaks];


    return {
        records: fromObjToArray(records, 'raceType'),
        figures: { jumps, flat },
        form: [...Object.values(form), ...specialRows],
        hasSpecial: !!specialRows.length,
    };
};

export default transformData;



// WEBPACK FOOTER //
// ./src/js/horse/form/transformData.js